import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import { UpdatesSection, CarouselSection, IndexSection } from '@/pages/home/components/ContentSectionsA';
import { TopicsSection, RankingSection, FeaturesSection, AppSection, MediaSection } from '@/pages/home/components/ContentSectionsB';
import { CardsSection, ContactSection, AboutSection, FaqSection, CommentsSection } from '@/pages/home/components/ContentSectionsC';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <MediaSection />
        <CardsSection />
        <ContactSection />
        <AboutSection />
        <FaqSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}